import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enlang from "./language/en.json";
import urlang from "./language/ur.json";
import frlang from "./language/fr.json";
import hilang from "./language/hi.json";
import delang from "./language/de.json";
import trlang from "./language/tr.json";
import eslang from "./language/es.json";
import itlang from "./language/it.json";
import rulang from "./language/ru.json";
import zhlang from "./language/zh.json";
import jalang from "./language/ja.json";
import kolang from "./language/ko.json";

    

// var language = ""
//  export   const handleLanguage = (lang) => {
//     console.log("lang is " + lang)
//            var  language = lang
//              console.log(language)
//            }
    

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: enlang },
      ur: { translation: urlang },
      fr: { translation: frlang },
      hi: { translation: hilang },
      de: { translation: delang },
      tr: { translation: trlang },
      es: { translation: eslang },
      it: { translation: itlang },
      ru: { translation: rulang },
      zh: { translation: zhlang },
      ja: { translation: jalang },
      ko: { translation: kolang },
    }, // ✅ Closing bracket correctly placed for 'resources'
    
    lng: "", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

export default i18n;
